import { render } from "./ExternalData.vue?vue&type=template&id=4cd8e843&scoped=true"
import script from "./ExternalData.vue?vue&type=script&lang=js"
export * from "./ExternalData.vue?vue&type=script&lang=js"

import "./ExternalData.vue?vue&type=style&index=0&id=4cd8e843&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd8e843"]])

export default __exports__